import React from 'react';
import { usePager } from '../../../helpers/pagination';
import PageIndicator from '../../Common/PageIndicator';
import Row from './Row';
import SideBar from '../../Common/SideBar';
import SpotlightHeader from '../../Common/Header';
import './BlazinByStore.scss';
const getFormattedData = (data, metadata) => {
  var _metadata$results, _metadata$boh_compari;
  const {
    top,
    own
  } = data;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const comparison_date = (_metadata$boh_compari = metadata.boh_comparison_date) !== null && _metadata$boh_compari !== void 0 ? _metadata$boh_compari : 'week';
  const description = 'This week\'s loyalty ranking, updated daily';
  const bohLocations = top.slice(0, results);
  const isOwnInRanking = (own === null || own === void 0 ? void 0 : own.ranking) <= results;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  return {
    own,
    comparison_date,
    description,
    bohLocations,
    isOwnInRanking,
    hide_poweredbyupshow
  };
};
const BlazinByStore = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    bohLocations,
    own,
    isOwnInRanking,
    description,
    hide_poweredbyupshow
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(bohLocations, duration * 1000, playing);
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "attachments-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: "ticket-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: "header-location"
  }, "Location"), /*#__PURE__*/React.createElement("p", {
    className: "header-variation"
  }, "Attachment rate")), page.map((loc, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${loc.location}=${index}`,
    location: loc,
    own: own,
    accent_color: accent_color
  })), !!own && !isOwnInRanking && /*#__PURE__*/React.createElement(Row, {
    key: `${own.location}`,
    location: own,
    own: own,
    accent_color: accent_color
  }), /*#__PURE__*/React.createElement("div", {
    className: "results-description"
  }, "Results ordered by Attachment")), pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  }))), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default BlazinByStore;